import useAvailableExtensions from "@mirage/settings/utils/useAvailableExtensions";
import { isExtensionInstalled } from "@mirage/shared/util/webExtensionsHelpers";

export const useShouldShowExtensionOnboardingStep = (): boolean => {
  const { extensionAvailableForBrowser } = useAvailableExtensions();
  return !isExtensionInstalled() && extensionAvailableForBrowser;
};
